import * as React from 'react';
import { Section } from '../Section';
import { LayoutBlock } from '../LayoutBlock';

export interface INewbuildingReviewsTeaserProps {
  reviewsCountText?: string;
  reviews: React.ReactElement;
  isQuestionsFeatureEnabled: boolean;
}

export const NewbuildingReviewsTeaser: React.FC<INewbuildingReviewsTeaserProps> = ({
  reviewsCountText,
  reviews,
  isQuestionsFeatureEnabled,
}) => {
  const tabName = React.useMemo(() => {
    if (isQuestionsFeatureEnabled) {
      return 'reviews/Отзывы и вопросы';
    }

    return reviewsCountText ? `reviews/${reviewsCountText}` : 'reviews/Отзывы';
  }, [reviewsCountText, isQuestionsFeatureEnabled]);

  return (
    <LayoutBlock>
      <Section id="reviews" data-nav-tab={tabName} data-mark={'NewbuildingReviews'}>
        {reviews}
      </Section>
    </LayoutBlock>
  );
};
